import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Mail, MapPin, Phone } from "lucide-react";
import logo from "../assets/images/logoH.png";
import { useLanguage } from "../context/LanguageContext";
import * as productsApi from "../api/productsApi";
import "./Footer.css";

export default function Footer() {
  const { t, isRTL, language } = useLanguage();
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    let cancelled = false;
    productsApi
      .fetchCollections()
      .then((data) => {
        if (!cancelled && Array.isArray(data)) {
          setCollections(data);
        }
      })
      .catch((err) => {
        console.error("Failed to load footer collections:", err);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container footer__grid">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src={logo} alt="TERRY LAND" style={{ height: "32px", objectFit: "contain" }} />
              <span>{t("brand.name")}</span>
            </div>
            <p className="footer__tagline">{t("footer.tagline")}</p>
            <div className="footer__social">
              <a href="https://www.instagram.com/terryland.eg/" aria-label="Instagram"><Instagram size={16} /></a>
              <a href="https://www.facebook.com/people/TERRY-LAND/61588050711260/" aria-label="Facebook"><Facebook size={16} /></a>
              <a href="https://x.com/TerryLand_eg" aria-label="Twitter"><Twitter size={16} /></a>
            </div>
          </div>

          <div className="footer__col">
            <h4>{t("footer.colShop")}</h4>
            <ul>
              {Array.isArray(collections) &&
                collections.map((c) => {
                  const displayName =
                    (isRTL || language === "ar") && c.arabicName?.trim()
                      ? c.arabicName.trim()
                      : c.name;
                  return (
                    <li key={c.id}>
                      <Link to={`/shop/${encodeURIComponent(c.name.toLowerCase())}`}>
                        {displayName}
                      </Link>
                    </li>
                  );
                })}
              <li><Link to="/shop">{t("home.viewAllProducts")}</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>{t("footer.colCompany")}</h4>
            <ul>
              <li><Link to="/about">{t("nav.about")}</Link></li>
              <li><Link to="/blog">{t("nav.blog")}</Link></li>
              <li><Link to="/careers">{isRTL ? "الوظائف" : "Careers"}</Link></li>
              <li><Link to="/press">{isRTL ? "الصحافة والإعلام" : "Press"}</Link></li>
              <li><Link to="/info-card">{isRTL ? "بطاقة التعريف" : "Info Card"}</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>{t("footer.colSupport")}</h4>
            <ul>
              <li><Link to="/contact">{t("nav.contact")}</Link></li>
              <li><Link to="/shipping">{isRTL ? "الشحن والإرجاع" : "Shipping & Returns"}</Link></li>
              <li><Link to="/faq">{isRTL ? "الأسئلة الشائعة" : "FAQ"}</Link></li>
              <li><Link to="/care">{isRTL ? "دليل العناية بالمنسوجات" : "Care Guide"}</Link></li>
            </ul>
          </div>

          <div className="footer__col footer__contact">
            <h4>{t("footer.colContact")}</h4>
            <ul>
              <li><Mail size={13} /><span>info@terryland.net</span></li>
                          <li><Phone size={13} /><span dir="ltr">+20 10 9992 1862</span></li>
              <li><MapPin size={13} /><span>{isRTL ? "شارع 400، مدينة العبور، محافظة القليوبية، مصر" : "Street 400, Obour, Al-Qalyubia Governorate, Cairo, Egypt"}</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__newsletter">
        <div className="container footer__newsletter-inner">
          <div>
            <p className="section-label">{isRTL ? "النشرة البريدية" : "Newsletter"}</p>
            <h3>{t("footer.newsletterTitle")}</h3>
          </div>
          <div className="footer__newsletter-form">
            <input type="email" placeholder={t("footer.newsletterPlaceholder")} />
            <button type="button" className="btn-primary">{t("action.subscribe")}</button>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>{t("footer.rights")}</p>
          <div className="footer__legal">
            <Link to="/info-card">{isRTL ? "بطاقة التعريف" : "Info Card"}</Link>
            <Link to="/privacy">{t("footer.privacy")}</Link>
            <Link to="/terms">{t("footer.terms")}</Link>
            <Link to="/cookies">{t("footer.cookies")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
